import { useState } from "react";
import { popular } from "../constants/popular";
import FoodCard from "./FoodCard";
import { useTranslation } from "react-i18next";
import banner1 from "../assets/img/header-banner.jpg";

const Menu = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isFilterOpen, setIsFilterOpen] = useState(false); // Added state for filter toggle
  const { t } = useTranslation("menu");

  return (
    <div className="bg-cream min-h-screen">
      <div
        className="relative w-full h-[150px] md:h-[150px]
       bg-center bg-cover bg-no-repeat flex justify-center items-center"
        style={{ backgroundImage: `url(${banner1})` }}
      >
        <div className="absolute inset-0 bg-white/60"></div>
        <h1
          data-aos="fade-up"
          className="relative uppercase text-2xl md:text-3xl font-bold text-center text-coffee-dark tracking-wide"
        >
          {t("order_food")}
          <div className="mt-2 mx-auto w-24 border-b-2 border-accent-gold"></div>
        </h1>
      </div>
      {/* Filter Section Container */}
      <div className="max-w-screen-xl mx-auto mb-5 p-2">
        {/* Filter Toggle Button */}
        <button
          onClick={() => setIsFilterOpen(!isFilterOpen)}
          className="flex items-center gap-2 px-6 py-2 bg-accent-gold text-coffee-dark font-bold rounded-lg hover:bg-yellow-400 hover:shadow-glow transition-all duration-300 mb-4"
        >
          <svg
            className={`w-5 h-5 transition-transform duration-300 ${isFilterOpen ? "rotate-180" : ""}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
            />
          </svg>
          {isFilterOpen ? "Close Filter" : "Filter Categories"}
        </button>

        {/* Filter List - Only shows when isFilterOpen is true */}
        {isFilterOpen && (
          <div data-aos="fade-down" className="w-full">
            <ul className="flex flex-wrap gap-3 border border-coffee-light/20 p-3 rounded-2xl justify-start bg-cream-dark/50 shadow-soft">
              {popular.map((item, i) => (
                <li key={i}>
                  <button
                    onClick={() => setSelectedCategory(item.title)}
                    className={`font-bold px-6 py-2 rounded-lg transition-colors duration-300 ${
                      selectedCategory === item.title
                        ? "bg-accent-gold text-coffee-dark shadow-sm"
                        : "text-coffee-medium hover:bg-accent-gold/20"
                    }`}
                  >
                    {item.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      <FoodCard selectedCategory={selectedCategory} />
    </div>
  );
};

export default Menu;
